import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  closeButton: {
    padding: '4px',
  },
  dialogActions: {
    padding: '16px',
    gap: '8px',
  },
  originalName: {
    marginBottom: '16px',
  },
  storiesTextMedium: {
    fontWeight: foundations.typography.fontWeight.medium,
    fontSize: '12px',
  },
  labelContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '4px',
  },
});
